export default __webpack_public_path__ + "media/images/users/user-eva-pool-270x270-9767d8d07c3ffcb2397f80cfe84f6d50.jpg";